import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './cipgroupspage.cssmodule.scss';
import CipGroupTable from './CipGroupTable';

class CipGroupsPage extends React.Component {

  handleFilterChanged(filter){
    const { loadCipGroups } = this.props;    
    loadCipGroups && loadCipGroups(filter);
  }

  render() {
    const { cipGroupContainer } = this.props;   
    const { cipGroupManagers } = this.props;     
    const { IsAdmin } = this.props;

    return (
      <div className="container cipgroupspage-component" styleName="cipgroupspage-component">
        <CipGroupTable IsAdmin={IsAdmin} cipGroupContainer={cipGroupContainer} cipGroupManagers={cipGroupManagers} onFilterChanged={this.handleFilterChanged.bind(this)}/>
      </div>
    );
  }
}

CipGroupsPage.displayName = 'CipGroupsPage';
CipGroupsPage.propTypes = {};
CipGroupsPage.defaultProps = {};

export default cssmodules(CipGroupsPage, styles);



// WEBPACK FOOTER //
// ./components/CipGroups/CipGroupsPage.js